// Team Insights — analytics, share card, monthly report (prefix `ins.`)
const en = {
  "ins.title": "Analytics",
  "ins.subtitle": "Real performance from your releases, YouTube, Spotify and earnings",
  "ins.periodLabel": "Period",
  "ins.period.7d": "Last 7 days",
  "ins.period.30d": "Last 30 days",
  "ins.period.90d": "Last 90 days",
  "ins.period.1y": "Last 12 months",
  "ins.period.all": "All time",
  "ins.periodShort.7d": "7D",
  "ins.periodShort.30d": "30D",
  "ins.periodShort.90d": "90D",
  "ins.periodShort.1y": "1Y",
  "ins.periodShort.all": "All",
  "ins.refresh": "Refresh",
  "ins.refreshFailed": "Couldn't refresh. Showing the last loaded data.",
  "ins.errorDesc": "We couldn't load your analytics. Please try again.",
  "ins.vsPrev": "vs previous period",
  "ins.updated": "Updated",
  "ins.monthlyReport": "Monthly report",
  "ins.otherCurrencies": "Earnings in other currencies are not included in these totals",
  "ins.onboard.title": "Let's light up your dashboard",
  "ins.onboard.desc": "Your analytics only show real data. Here's how numbers start flowing in:",
  "ins.onboard.spotify": "Add your Spotify artist profile to your tracks to see followers and popularity.",
  "ins.onboard.youtube": "YouTube views appear once our team links your video to a release.",
  "ins.onboard.earnings": "Earnings appear here as soon as store reports are processed for your releases.",
  "ins.cta.connectSpotify": "Connect Spotify",
  "ins.cta.viewReleases": "View releases",
  "ins.cta.newRelease": "Create a release",
  "ins.kpi.earnings": "Earnings · {period}",
  "ins.kpi.allTime": "All time",
  "ins.kpi.noEarnings": "No earnings reported yet",
  "ins.kpi.ytViews": "YouTube views",
  "ins.kpi.ytLikes": "YouTube likes",
  "ins.kpi.inPeriod": "in this period",
  "ins.kpi.likes": "likes",
  "ins.kpi.videos": "videos",
  "ins.kpi.noYoutube": "No YouTube video linked yet",
  "ins.kpi.spFollowers": "Spotify followers",
  "ins.kpi.followersShort": "followers",
  "ins.kpi.profiles": "linked profile(s)",
  "ins.kpi.noSpotify": "No Spotify profile linked yet",
  "ins.kpi.spPopularity": "Spotify popularity",
  "ins.kpi.popularityHint": "Average across your linked profiles",
  "ins.kpi.popularityInfo": "Spotify's own 0–100 score, based on how many recent plays your tracks get. Updated daily from the Spotify API.",
  "ins.chart.title": "Trend",
  "ins.chart.metric": "Chart metric",
  "ins.chart.earnings": "Earnings",
  "ins.chart.youtube": "YouTube",
  "ins.chart.ytGained": "New views",
  "ins.chart.noEarningsTitle": "No earnings in this period",
  "ins.chart.noEarningsDesc": "When store reports for your releases are processed, your earnings trend will appear here.",
  "ins.chart.noYtTitle": "No YouTube history yet",
  "ins.chart.noYtDesc": "View history is recorded daily once a YouTube video is linked to one of your releases.",
  "ins.platforms.title": "Earnings by platform",
  "ins.byTrack.title": "Earnings by track",
  "ins.byTrack.emptyTitle": "No earnings yet",
  "ins.byTrack.emptyDesc": "Your top-earning tracks will be ranked here once revenue is reported.",
  "ins.spotify.title": "Spotify profiles",
  "ins.empty.spTitle": "No Spotify profile linked",
  "ins.empty.spDesc": "Link your Spotify artist profile on your tracks to track followers and popularity.",
  "ins.empty.ytTitle": "No YouTube video linked",
  "ins.countries.title": "Earnings by country",
  "ins.releases.title": "Your releases",
  "ins.releases.live": "live",
  "ins.releases.ytHint": "YouTube columns fill in once a video is linked to the release.",
  "ins.releases.emptyTitle": "No releases yet",
  "ins.releases.emptyDesc": "Create your first release to start collecting stats.",
  "ins.col.release": "Release",
  "ins.col.track": "Track",
  "ins.col.status": "Status",
  "ins.col.ytViews": "YT views",
  "ins.col.ytLikes": "YT likes",
  "ins.col.earnings": "Earnings",
  "ins.col.earningsAll": "Earnings (all time)",
  "ins.status.live": "Live",
  "ins.status.approved": "Approved",
  "ins.status.pending": "Pending",
  "ins.status.rejected": "Rejected",
  "ins.status.draft": "Draft",
  "ins.share.button": "Share stats",
  "ins.share.title": "Share your stats",
  "ins.share.desc": "A card with your real numbers for this period — ready for Stories or a post.",
  "ins.share.format": "Format",
  "ins.share.story": "Story",
  "ins.share.square": "Post",
  "ins.share.download": "Download PNG",
  "ins.share.downloaded": "Card downloaded",
  "ins.share.downloadFailed": "Couldn't create the image",
  "ins.share.myStats": "My stats",
  "ins.share.ytViews": "YouTube views",
  "ins.share.ytGained": "New YouTube views",
  "ins.share.spFollowers": "Spotify followers",
  "ins.share.earnings": "Earnings",
  "ins.share.liveReleases": "Live releases",
  "ins.share.topRelease": "Top release:",
  "ins.share.footer": "Distributed with EAM Music",
  "ins.report.title": "Monthly report",
  "ins.report.heading": "Monthly performance report",
  "ins.report.print": "Print / Save PDF",
  "ins.report.close": "Close report",
  "ins.report.generated": "Generated",
  "ins.report.earnings": "Earnings",
  "ins.report.periodEarnings": "Earnings (last 30 days)",
  "ins.report.allTime": "All-time earnings",
  "ins.report.balance": "Current balance",
  "ins.report.withdrawable": "Withdrawable balance",
  "ins.report.noEarnings": "No earnings were reported in this period.",
  "ins.report.ytGained": "New views (last 30 days)",
  "ins.report.releases": "Releases",
  "ins.report.footer": "This report contains only data recorded in your EAM Music account. Store reports may arrive with a delay.",
};

const tr = {
  "ins.title": "İstatistikler",
  "ins.subtitle": "Yayınlarınız, YouTube, Spotify ve kazançlarınızdan gerçek performans",
  "ins.periodLabel": "Dönem",
  "ins.period.7d": "Son 7 gün",
  "ins.period.30d": "Son 30 gün",
  "ins.period.90d": "Son 90 gün",
  "ins.period.1y": "Son 12 ay",
  "ins.period.all": "Tüm zamanlar",
  "ins.periodShort.7d": "7G",
  "ins.periodShort.30d": "30G",
  "ins.periodShort.90d": "90G",
  "ins.periodShort.1y": "1Y",
  "ins.periodShort.all": "Tümü",
  "ins.refresh": "Yenile",
  "ins.refreshFailed": "Yenilenemedi. Son yüklenen veriler gösteriliyor.",
  "ins.errorDesc": "İstatistikleriniz yüklenemedi. Lütfen tekrar deneyin.",
  "ins.vsPrev": "önceki döneme göre",
  "ins.updated": "Güncellendi",
  "ins.monthlyReport": "Aylık rapor",
  "ins.otherCurrencies": "Diğer para birimlerindeki kazançlar bu toplamlara dahil değildir",
  "ins.onboard.title": "Panelinizi canlandıralım",
  "ins.onboard.desc": "İstatistikler yalnızca gerçek verileri gösterir. Veriler şöyle akmaya başlar:",
  "ins.onboard.spotify": "Takipçi ve popülerliği görmek için parçalarınıza Spotify sanatçı profilinizi ekleyin.",
  "ins.onboard.youtube": "Ekibimiz videonuzu bir yayına bağladığında YouTube izlenmeleri görünür.",
  "ins.onboard.earnings": "Yayınlarınız için mağaza raporları işlendiğinde kazançlar burada görünür.",
  "ins.cta.connectSpotify": "Spotify'ı bağla",
  "ins.cta.viewReleases": "Yayınları gör",
  "ins.cta.newRelease": "Yayın oluştur",
  "ins.kpi.earnings": "Kazanç · {period}",
  "ins.kpi.allTime": "Tüm zamanlar",
  "ins.kpi.noEarnings": "Henüz kazanç raporlanmadı",
  "ins.kpi.ytViews": "YouTube izlenme",
  "ins.kpi.ytLikes": "YouTube beğeni",
  "ins.kpi.inPeriod": "bu dönemde",
  "ins.kpi.likes": "beğeni",
  "ins.kpi.videos": "video",
  "ins.kpi.noYoutube": "Henüz bağlı YouTube videosu yok",
  "ins.kpi.spFollowers": "Spotify takipçi",
  "ins.kpi.followersShort": "takipçi",
  "ins.kpi.profiles": "bağlı profil",
  "ins.kpi.noSpotify": "Henüz bağlı Spotify profili yok",
  "ins.kpi.spPopularity": "Spotify popülerlik",
  "ins.kpi.popularityHint": "Bağlı profillerinizin ortalaması",
  "ins.kpi.popularityInfo": "Spotify'ın kendi 0–100 puanı; parçalarınızın son dönemdeki dinlenmelerine dayanır. Spotify API'den günlük güncellenir.",
  "ins.chart.title": "Trend",
  "ins.chart.metric": "Grafik metriği",
  "ins.chart.earnings": "Kazanç",
  "ins.chart.youtube": "YouTube",
  "ins.chart.ytGained": "Yeni izlenme",
  "ins.chart.noEarningsTitle": "Bu dönemde kazanç yok",
  "ins.chart.noEarningsDesc": "Yayınlarınızın mağaza raporları işlendiğinde kazanç trendiniz burada görünecek.",
  "ins.chart.noYtTitle": "Henüz YouTube geçmişi yok",
  "ins.chart.noYtDesc": "Bir YouTube videosu yayınınıza bağlandığında izlenme geçmişi her gün kaydedilir.",
  "ins.platforms.title": "Platforma göre kazanç",
  "ins.byTrack.title": "Parçaya göre kazanç",
  "ins.byTrack.emptyTitle": "Henüz kazanç yok",
  "ins.byTrack.emptyDesc": "Gelir raporlandığında en çok kazandıran parçalarınız burada sıralanacak.",
  "ins.spotify.title": "Spotify profilleri",
  "ins.empty.spTitle": "Bağlı Spotify profili yok",
  "ins.empty.spDesc": "Takipçi ve popülerliği izlemek için parçalarınıza Spotify sanatçı profilinizi bağlayın.",
  "ins.empty.ytTitle": "Bağlı YouTube videosu yok",
  "ins.countries.title": "Ülkeye göre kazanç",
  "ins.releases.title": "Yayınlarınız",
  "ins.releases.live": "yayında",
  "ins.releases.ytHint": "Yayına bir video bağlandığında YouTube sütunları dolar.",
  "ins.releases.emptyTitle": "Henüz yayın yok",
  "ins.releases.emptyDesc": "İstatistik toplamaya başlamak için ilk yayınınızı oluşturun.",
  "ins.col.release": "Yayın",
  "ins.col.track": "Parça",
  "ins.col.status": "Durum",
  "ins.col.ytViews": "YT izlenme",
  "ins.col.ytLikes": "YT beğeni",
  "ins.col.earnings": "Kazanç",
  "ins.col.earningsAll": "Kazanç (tümü)",
  "ins.status.live": "Yayında",
  "ins.status.approved": "Onaylandı",
  "ins.status.pending": "Beklemede",
  "ins.status.rejected": "Reddedildi",
  "ins.status.draft": "Taslak",
  "ins.share.button": "İstatistik paylaş",
  "ins.share.title": "İstatistiklerini paylaş",
  "ins.share.desc": "Bu döneme ait gerçek rakamlarınla bir kart — Hikaye veya gönderi için hazır.",
  "ins.share.format": "Format",
  "ins.share.story": "Hikaye",
  "ins.share.square": "Gönderi",
  "ins.share.download": "PNG indir",
  "ins.share.downloaded": "Kart indirildi",
  "ins.share.downloadFailed": "Görsel oluşturulamadı",
  "ins.share.myStats": "İstatistiklerim",
  "ins.share.ytViews": "YouTube izlenme",
  "ins.share.ytGained": "Yeni YouTube izlenme",
  "ins.share.spFollowers": "Spotify takipçi",
  "ins.share.earnings": "Kazanç",
  "ins.share.liveReleases": "Yayındaki parçalar",
  "ins.share.topRelease": "Öne çıkan:",
  "ins.share.footer": "EAM Music ile dağıtıldı",
  "ins.report.title": "Aylık rapor",
  "ins.report.heading": "Aylık performans raporu",
  "ins.report.print": "Yazdır / PDF kaydet",
  "ins.report.close": "Raporu kapat",
  "ins.report.generated": "Oluşturulma",
  "ins.report.earnings": "Kazançlar",
  "ins.report.periodEarnings": "Kazanç (son 30 gün)",
  "ins.report.allTime": "Toplam kazanç",
  "ins.report.balance": "Güncel bakiye",
  "ins.report.withdrawable": "Çekilebilir bakiye",
  "ins.report.noEarnings": "Bu dönemde kazanç raporlanmadı.",
  "ins.report.ytGained": "Yeni izlenme (son 30 gün)",
  "ins.report.releases": "Yayınlar",
  "ins.report.footer": "Bu rapor yalnızca EAM Music hesabınızda kayıtlı verileri içerir. Mağaza raporları gecikmeli gelebilir.",
};

const es = {
  "ins.title": "Estadísticas",
  "ins.subtitle": "Rendimiento real de tus lanzamientos, YouTube, Spotify y ganancias",
  "ins.periodLabel": "Periodo",
  "ins.period.7d": "Últimos 7 días",
  "ins.period.30d": "Últimos 30 días",
  "ins.period.90d": "Últimos 90 días",
  "ins.period.1y": "Últimos 12 meses",
  "ins.period.all": "Todo el tiempo",
  "ins.periodShort.7d": "7D",
  "ins.periodShort.30d": "30D",
  "ins.periodShort.90d": "90D",
  "ins.periodShort.1y": "1A",
  "ins.periodShort.all": "Todo",
  "ins.refresh": "Actualizar",
  "ins.refreshFailed": "No se pudo actualizar. Mostrando los últimos datos cargados.",
  "ins.errorDesc": "No pudimos cargar tus estadísticas. Inténtalo de nuevo.",
  "ins.vsPrev": "vs. periodo anterior",
  "ins.updated": "Actualizado",
  "ins.monthlyReport": "Informe mensual",
  "ins.otherCurrencies": "Las ganancias en otras monedas no se incluyen en estos totales",
  "ins.onboard.title": "Demos vida a tu panel",
  "ins.onboard.desc": "Tus estadísticas solo muestran datos reales. Así empiezan a llegar:",
  "ins.onboard.spotify": "Añade tu perfil de artista de Spotify a tus pistas para ver seguidores y popularidad.",
  "ins.onboard.youtube": "Las vistas de YouTube aparecen cuando nuestro equipo vincula tu vídeo a un lanzamiento.",
  "ins.onboard.earnings": "Las ganancias aparecen aquí en cuanto se procesan los informes de las tiendas.",
  "ins.cta.connectSpotify": "Conectar Spotify",
  "ins.cta.viewReleases": "Ver lanzamientos",
  "ins.cta.newRelease": "Crear lanzamiento",
  "ins.kpi.earnings": "Ganancias · {period}",
  "ins.kpi.allTime": "Total",
  "ins.kpi.noEarnings": "Aún no hay ganancias reportadas",
  "ins.kpi.ytViews": "Vistas en YouTube",
  "ins.kpi.ytLikes": "Me gusta en YouTube",
  "ins.kpi.inPeriod": "en este periodo",
  "ins.kpi.likes": "me gusta",
  "ins.kpi.videos": "vídeos",
  "ins.kpi.noYoutube": "Aún no hay vídeo de YouTube vinculado",
  "ins.kpi.spFollowers": "Seguidores en Spotify",
  "ins.kpi.followersShort": "seguidores",
  "ins.kpi.profiles": "perfil(es) vinculado(s)",
  "ins.kpi.noSpotify": "Aún no hay perfil de Spotify vinculado",
  "ins.kpi.spPopularity": "Popularidad en Spotify",
  "ins.kpi.popularityHint": "Media de tus perfiles vinculados",
  "ins.kpi.popularityInfo": "Puntuación propia de Spotify (0–100) basada en las reproducciones recientes de tus pistas. Se actualiza a diario desde la API de Spotify.",
  "ins.chart.title": "Tendencia",
  "ins.chart.metric": "Métrica del gráfico",
  "ins.chart.earnings": "Ganancias",
  "ins.chart.youtube": "YouTube",
  "ins.chart.ytGained": "Nuevas vistas",
  "ins.chart.noEarningsTitle": "Sin ganancias en este periodo",
  "ins.chart.noEarningsDesc": "Cuando se procesen los informes de las tiendas, tu tendencia de ganancias aparecerá aquí.",
  "ins.chart.noYtTitle": "Aún no hay historial de YouTube",
  "ins.chart.noYtDesc": "El historial de vistas se registra a diario cuando un vídeo se vincula a uno de tus lanzamientos.",
  "ins.platforms.title": "Ganancias por plataforma",
  "ins.byTrack.title": "Ganancias por pista",
  "ins.byTrack.emptyTitle": "Aún no hay ganancias",
  "ins.byTrack.emptyDesc": "Tus pistas con más ganancias aparecerán aquí cuando se reporten ingresos.",
  "ins.spotify.title": "Perfiles de Spotify",
  "ins.empty.spTitle": "No hay perfil de Spotify vinculado",
  "ins.empty.spDesc": "Vincula tu perfil de artista de Spotify en tus pistas para seguir seguidores y popularidad.",
  "ins.empty.ytTitle": "No hay vídeo de YouTube vinculado",
  "ins.countries.title": "Ganancias por país",
  "ins.releases.title": "Tus lanzamientos",
  "ins.releases.live": "publicados",
  "ins.releases.ytHint": "Las columnas de YouTube se rellenan cuando se vincula un vídeo al lanzamiento.",
  "ins.releases.emptyTitle": "Aún no hay lanzamientos",
  "ins.releases.emptyDesc": "Crea tu primer lanzamiento para empezar a recopilar estadísticas.",
  "ins.col.release": "Lanzamiento",
  "ins.col.track": "Pista",
  "ins.col.status": "Estado",
  "ins.col.ytViews": "Vistas YT",
  "ins.col.ytLikes": "Me gusta YT",
  "ins.col.earnings": "Ganancias",
  "ins.col.earningsAll": "Ganancias (total)",
  "ins.status.live": "Publicado",
  "ins.status.approved": "Aprobado",
  "ins.status.pending": "Pendiente",
  "ins.status.rejected": "Rechazado",
  "ins.status.draft": "Borrador",
  "ins.share.button": "Compartir estadísticas",
  "ins.share.title": "Comparte tus estadísticas",
  "ins.share.desc": "Una tarjeta con tus cifras reales de este periodo, lista para Stories o una publicación.",
  "ins.share.format": "Formato",
  "ins.share.story": "Story",
  "ins.share.square": "Publicación",
  "ins.share.download": "Descargar PNG",
  "ins.share.downloaded": "Tarjeta descargada",
  "ins.share.downloadFailed": "No se pudo crear la imagen",
  "ins.share.myStats": "Mis estadísticas",
  "ins.share.ytViews": "Vistas en YouTube",
  "ins.share.ytGained": "Nuevas vistas en YouTube",
  "ins.share.spFollowers": "Seguidores en Spotify",
  "ins.share.earnings": "Ganancias",
  "ins.share.liveReleases": "Lanzamientos publicados",
  "ins.share.topRelease": "Destacado:",
  "ins.share.footer": "Distribuido con EAM Music",
  "ins.report.title": "Informe mensual",
  "ins.report.heading": "Informe mensual de rendimiento",
  "ins.report.print": "Imprimir / Guardar PDF",
  "ins.report.close": "Cerrar informe",
  "ins.report.generated": "Generado",
  "ins.report.earnings": "Ganancias",
  "ins.report.periodEarnings": "Ganancias (últimos 30 días)",
  "ins.report.allTime": "Ganancias totales",
  "ins.report.balance": "Saldo actual",
  "ins.report.withdrawable": "Saldo retirable",
  "ins.report.noEarnings": "No se reportaron ganancias en este periodo.",
  "ins.report.ytGained": "Nuevas vistas (últimos 30 días)",
  "ins.report.releases": "Lanzamientos",
  "ins.report.footer": "Este informe solo contiene datos registrados en tu cuenta de EAM Music. Los informes de tiendas pueden llegar con retraso.",
};

export default { en, tr, es };
